
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/[project]",
      function () {
        return require("private-next-pages/works/[project].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/[project]"])
      });
    }
  